import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../Services/api.service';
import { AuthService } from '../../../Services/auth.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SpinnerComponent } from "../../../Common/Components/spinner/spinner.component";
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { AddProductDetailsComponent } from "../add-product-details/add-product-details.component";
import { NzTagModule } from 'ng-zorro-antd/tag';
import { AssociateLotComponent } from "../associate-lot/associate-lot.component";
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { CatalogPreviewComponent } from '../catalog-preview/catalog-preview.component';
import { Router } from '@angular/router';
import { MasterCatalogComponent } from '../../master-catalog/master-catalog.component';
import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import { RichTextFieldComponent } from '../../../Common/Components/rich-text-field/rich-text-field.component';
import { Toolbar } from 'ngx-editor';
import { DecodeSpecialCharPipe } from '../../../Common/Components/pipe/DecodeSpecialCharPipe/decode-special-char.pipe';

@Component({
  selector: 'app-add-edit-category',
  standalone: true,
  imports: [NzIconModule, NzSpinModule, NzLayoutModule, NzButtonModule, ConfirmPopupComponent,
    NzSelectModule, NzDrawerModule, NzTagModule,
    CommonModule, FormsModule, ReactiveFormsModule,
    CatalogPreviewComponent, SpinnerComponent, NzModalModule,
    NzSwitchModule, NzCollapseModule, AddProductDetailsComponent,
    AssociateLotComponent, MasterCatalogComponent, NzTooltipDirective, DecodeSpecialCharPipe,
    RichTextFieldComponent],
  templateUrl: './add-edit-category.component.html',
  styleUrl: './add-edit-category.component.scss'
})
export class AddEditCategoryComponent implements OnChanges, OnInit {
  @Input() seqNumber: any = "";
  @Input() catalogId: any = "";
  @Input() lots: any = "";
  @Input() categoryList: any = "";
  @Input() intiateNewCategory: any = "";
  @Output() emitCategoryTreeRefresh = new EventEmitter<string>();
  @Output() resetSelectedCategory = new EventEmitter<string>();
  @Output() emitUpdateLots = new EventEmitter<any>();
  @ViewChild('productDetails') productDetails!: ElementRef;
  addEditCategoryForm: FormGroup = new FormGroup({});
  categoryData: any = {};
  isAddCategory: boolean = true;
  showAddCategoryForm: boolean = false;
  selectedProdctDetails: any = [];
  parentCategories: any = [];
  activeProdctCollapse: boolean = true;
  addProdctSwitch: boolean = false;
  prodctPanel: boolean = false;
  editMCVisible: boolean = false;
  toggleProdct: boolean = false;
  lotPanel: boolean = false;
  categoryFields = [
    { type: "input", label: "Sequence No", placeholder: "", value: 190025, formControlName: "seqNumber", required: false, disabled: false },
    { type: "dropdown", label: "Parent Category", placeholder: "", value: "Select", formControlName: "parentNode", required: true, disabled: false },
    { type: "input", label: "Name", placeholder: "Enter Category", value: "Category", formControlName: "categoryName", required: true, disabled: false },
    { type: "textarea", label: "Description", placeholder: "Enter Description", value: "", formControlName: "categoryDesc", required: true, disabled: false, rows: 1 },
    { type: "accordion", label: "Enter Product Details", placeholder: "", value: "", formControlName: "productDetails", required: false, disabled: false },
    { type: "input", label: "Custom Field 1", value: "", formControlName: "customField1", required: false, disabled: false, richTextEditor: true },
    { type: "input", label: "Custom Field 2", value: "", formControlName: "customField2", required: false, disabled: false, richTextEditor: true },
    { type: "input", label: "Category Image Path", value: "", formControlName: "categoryImagePath", required: false, disabled: false },
    { type: "input", label: "Category Swatch Image Path", value: "", formControlName: "categorySwatchImagePath", required: false, disabled: false },
    { type: "input", label: "Category Thumbnail Image Path", value: "", formControlName: "categoryThumbnailImagePath", required: false, disabled: false },
    { type: "input", label: "Category Zoom Image Path", value: "", formControlName: "categoryZoomImagePath", required: true, disabled: false },
    { type: "input", label: "Image Master Path", value: "", formControlName: "scene7ImagePath", required: true, disabled: false },
    { type: "input", label: "Size Chart HTML Path", value: "", formControlName: "sizeChartHtmlPath", required: false, disabled: false },
    { type: "input", label: "Dim1 Name", value: "", formControlName: "dim1", required: false, disabled: false },
    { type: "input", label: "Dim2 Name", value: "", formControlName: "dim2", required: false, disabled: false },
    { type: "textarea", label: "Tooltip", placeholder: "Enter Tooltip", value: "", formControlName: "tooltip", required: true, disabled: false },
    { type: "dropdown", label: "New Product", value: "", formControlName: "newProduct", required: false, disabled: false },
    { type: "dropdown", label: "CAT Level", placeholder: "", value: "Select", formControlName: "catLevel", required: false, disabled: true },
    { type: "dropdown", label: "Gender", placeholder: "", value: "Select", formControlName: "gender", required: false, disabled: true },
    { type: "checkbox", label: "UL Classified", value: "", formControlName: "ULClassified", required: false, disabled: true },
    { type: "checkbox", label: "Fetch from Image Master", value: "", formControlName: "fetchFromScene7", required: true, disabled: false },
    { type: "checkbox", label: "Activate Colorization", value: "", formControlName: "activateColorization", required: false, disabled: false },
    { type: "checkbox", label: "Media Set", value: "", formControlName: "mediaSet", required: false, disabled: false },
    { type: "checkbox", label: "Hide on Web", value: "", formControlName: "hideOnWeb", required: false, disabled: false },
  ];
  isLoadingData: boolean = false;
  invalidForm: boolean = false;
  newProductList = [
    { id: 0, value: 'Select' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Sale' },
    { id: 3, value: 'While supplies last' }
  ];
  genderList = [
    { id: 0, value: 'Unisex' },
    { id: 1, value: 'Male' },
    { id: 2, value: 'Female' }
  ];
  catLevelList = [
    { id: 1, value: 'CAT Level 1' },
    { id: 2, value: 'CAT Level 2' },
    { id: 3, value: 'CAT Level 3' },
    { id: 4, value: 'CAT Level 4' }
  ];
  selectedProdctId: any;
  selectedVersion: any;
  copiedProdctDetails: any;
  currentCategorySeq: any;
  activeTag: boolean = true;
  showModal: boolean = false;
  lotUpdate: boolean = false;
  imageLoading: boolean = false;
  previewModal: boolean = false;
  showMultiLotModal: boolean = false;
  previewData: any;
  categoryPayload: any;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike']
  ];

  constructor(public apiService: ApiService, private fb: FormBuilder, private router: Router,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.initAddForm();
  }

  switchForm(evt: any,validate?:boolean) {
    if(validate){
    this.checkParentNodeFallback();
    }
    if (evt) {
      this.categoryFields.map(res => {
        if (res.label != 'Sequence No') {
          res.required = true;
        }
      });

      this.addEditCategoryForm.get('ULClassified')?.disable();
      this.addEditCategoryForm.get('gender')?.disable();
      this.addEditCategoryForm.get('catLevel')?.disable();
      this.addEditCategoryForm.get('style')?.disable();
      if (this.addEditCategoryForm.get('parentNode')?.value == 0) {
        this.addEditCategoryForm.get('parentNode')?.setValue('');
      }
      this.addEditCategoryForm.get('parentNode')?.setValidators([Validators.required]);
      this.addEditCategoryForm.get('parentNode')?.updateValueAndValidity();
      if (this.isAddCategory) {
        this.prodctPanel = true;
      }
    }
    else {
      this.categoryFields.map(res => {
        if (res.label == 'Parent Category' || res.label == 'Name' || res.label == 'Description'
          || res.label == 'Category Zoom Image Path' || res.label == 'Image Master Path' ||
          res.label == 'Tooltip' || res.label == 'Fetch from Image Master' ||
          res.label == 'Hide on Web'
        ) {
          res.required = true;
        }
        else {
          res.required = false;
        }
      });
      this.addEditCategoryForm.get('parentNode')?.clearValidators();
      this.addEditCategoryForm.get('parentNode')?.updateValueAndValidity();
    }

  }

  checkParentNodeFallback() {
    if (!this.parentCategories || !this.currentCategorySeq) {
      return;
    }

    const isSeqPresent = this.parentCategories.some(
      (item: any) => item.seqno === this.currentCategorySeq
    );
    if (!isSeqPresent) {
      this.addEditCategoryForm.get('parentNode')?.setValue('0');
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.catalogId != '') {
      this.getParentCategories();
    }

    if (changes['seqNumber']) {
      if (this.seqNumber != '') {
        this.getCategoryDetail();
      } else {
        this.initAddForm();
      }
    }
  }

  onCancel() {
    this.showAddCategoryForm = false;
    this.currentCategorySeq = '';
    this.emitCategoryTreeRefresh.emit('reset');
  }

  resetForm() {
    if (this.isAddCategory) {
      this.selectedProdctId = '';
      this.selectedVersion = '';
      this.addEditCategoryForm.reset();
      this.copiedProdctDetails = [];
      this.addProdctSwitch = false;
      this.switchForm(false);
      this.addEditCategoryForm.get('seqNumber')?.enable();
      if (this.currentCategorySeq)
        this.addEditCategoryForm.get('parentNode')?.setValue(this.currentCategorySeq);
    }
    else {
      if (this.categoryData?.styleId)
        this.loadCategoryForm();
    }
    this.showModal = false
  }
  getParentCategories() {
    this.apiService.getParentCategories(this.catalogId, this.seqNumber ? this.seqNumber : '0').subscribe((res: any) => {
      this.parentCategories = res;
    })
  }

  validateFetchImage() {
    if (this.addEditCategoryForm.get('fetchFromScene7')?.value) {
      this.addEditCategoryForm.get('categoryImagePath')?.disable();
      this.addEditCategoryForm.get('categoryThumbnailImagePath')?.disable();
      this.addEditCategoryForm.get('categoryZoomImagePath')?.disable();
      this.addEditCategoryForm.get('scene7ImagePath')?.enable();
      this.addEditCategoryForm.get('mediaSet')?.enable();
    }
    else {
      this.addEditCategoryForm.get('mediaSet')?.disable();
      this.addEditCategoryForm.get('scene7ImagePath')?.disable();
    }
  }

  initAddForm() {
    this.categoryFields[0].required = false;
    this.categoryData = {};
    this.copiedProdctDetails = [];
    this.isAddCategory = true;
    this.addProdctSwitch = false;
    this.selectedProdctId = '';
    this.selectedVersion = '';
    this.invalidForm = false;
    this.addEditCategoryForm = this.fb.group({
      seqNumber: [''],
      parentNode: [this.currentCategorySeq],
      categoryName: ['', [Validators.required, Validators.maxLength(100)]],
      categoryDesc: ['', [Validators.required, Validators.maxLength(100)]],
      customField1: ['', Validators.maxLength(500)],
      customField2: ['', Validators.maxLength(500)],
      categoryImagePath: ['', Validators.maxLength(50)],
      categorySwatchImagePath: ['', Validators.maxLength(50)],
      sizeChartHtmlPath: ['', Validators.maxLength(50)],
      categoryThumbnailImagePath: ['', Validators.maxLength(50)],
      categoryZoomImagePath: ['', Validators.maxLength(50)],
      dim1: ['', Validators.maxLength(50)],
      dim2: ['', Validators.maxLength(50)],
      scene7ImagePath: ['', [Validators.required, Validators.maxLength(50)]],
      tooltip: ['', Validators.maxLength(100)],
      fetchFromScene7: [true],
      activateColorization: [''],
      newProduct: [0],
      ULClassified: [],
      catLevel: [],
      gender: [],
      mediaSet: [''],
      hideOnWeb: [''],
      internalComments: ['', Validators.maxLength(2500)]
    });
    this.switchForm(this.addProdctSwitch,true);
    this.validateFetchImage();
    this.addEditCategoryForm.get('fetchFromScene7')?.valueChanges.subscribe(val => {
      if (val) {
        this.addEditCategoryForm.get('categoryImagePath')?.setValue('');
        this.addEditCategoryForm.get('categoryThumbnailImagePath')?.setValue('');
        this.addEditCategoryForm.get('categoryZoomImagePath')?.setValue('');
        this.addEditCategoryForm.get('categoryImagePath')?.disable();
        this.addEditCategoryForm.get('categoryThumbnailImagePath')?.disable();
        this.addEditCategoryForm.get('categoryZoomImagePath')?.disable();
        this.addEditCategoryForm.get('mediaSet')?.enable();
        this.addEditCategoryForm.get('scene7ImagePath')?.enable();
        this.addEditCategoryForm.get('scene7ImagePath')?.setValidators([Validators.required]);
        this.addEditCategoryForm.get('scene7ImagePath')?.updateValueAndValidity();
      }
      else {
        this.addEditCategoryForm.get('categoryImagePath')?.enable();
        this.addEditCategoryForm.get('categoryThumbnailImagePath')?.enable();
        this.addEditCategoryForm.get('categoryZoomImagePath')?.enable();
        this.addEditCategoryForm.get('scene7ImagePath')?.setValue('');
        this.addEditCategoryForm.get('scene7ImagePath')?.disable();
        this.addEditCategoryForm.get('mediaSet')?.disable();
        this.addEditCategoryForm.get('scene7ImagePath')?.clearValidators();
        this.addEditCategoryForm.get('mediaSet')?.setValue('');
        this.addEditCategoryForm.get('scene7ImagePath')?.setErrors(null);
        this.addEditCategoryForm.get('scene7ImagePath')?.updateValueAndValidity();
      }
    })
    this.addEditCategoryForm.get('activateColorization')?.valueChanges.subscribe(val => {
      if (val) {
        this.addEditCategoryForm.get('categorySwatchImagePath')?.setValue('');
        this.addEditCategoryForm.get('categorySwatchImagePath')?.disable();
      }
      else {
        this.addEditCategoryForm.get('categorySwatchImagePath')?.enable();
      }
    })
    this.addEditCategoryForm.get('scene7ImagePath')?.valueChanges.subscribe(val => {
      if (val) {
        this.addEditCategoryForm.get('scene7ImagePath')?.patchValue(val.toUpperCase(), { emitEvent: false });
      }
    })

    this.addEditCategoryForm.get('scene7ImagePath')?.valueChanges.subscribe(val => {
      if (val) {
        this.addEditCategoryForm.get('scene7ImagePath')?.patchValue(val.toUpperCase(), { emitEvent: false });
      }

    })
  }

  getCategoryDetail() {
    this.isLoadingData = true;
    this.apiService.getCategoryDetailById(this.seqNumber).subscribe(response => {
      this.isLoadingData = false;
      this.categoryData = response;
      this.selectedProdctId = this.categoryData?.styleId;
      this.selectedVersion = this.categoryData?.version;
      this.showAddCategoryForm = true;
      this.isAddCategory = false;
      this.categoryFields[0].required = true;
      this.addEditCategoryForm.get('seqNumber')?.disable();
      if (this.categoryData.associatedLots && this.categoryData.associatedLots.length > 0) {
        this.lots = this.categoryData.associatedLots;
      }
      this.loadCategoryForm();
    })
  }

  getTitle() {
    return this.isAddCategory ? this.getSubTitle() : 'Edit - ' + this.categoryData.categoryName
  }

  getSubTitle() {
    return this.addProdctSwitch ? 'New Product' : 'New Category'
  }

  getApplyMasterCatalogText() {
    return (this.isAddCategory && this.addProdctSwitch) ? 'Apply Style From Master Catalog' : 'Change Style';
  }

  decodeHtml(value: string) {
    const txt = document.createElement("textarea");
    txt.innerHTML = value;
    return txt.value;
  }


  loadCategoryForm() {
    this.currentCategorySeq = this.categoryData.categorySeqNo;
    this.addEditCategoryForm.patchValue({
      seqNumber: this.categoryData.categorySeqNo,
      parentNode: this.categoryData.parentCategorySeqNo,
      categoryName: this.decodeHtml(this.categoryData.categoryName),
      categoryDesc: this.decodeHtml(this.categoryData.categoryShortDescription),
      categoryImagePath: this.categoryData.categoryImagePath,
      categorySwatchImagePath: this.categoryData.categorySwatchImagePath,
      sizeChartHtmlPath: this.categoryData.sizeChartHTMLPath,
      categoryThumbnailImagePath: this.categoryData.categoryThumbnailImagePath,
      categoryZoomImagePath: this.categoryData.categoryZoomImagePath,
      dim1: this.categoryData.dim1,
      dim2: this.categoryData.dim2,
      scene7ImagePath: this.categoryData.scene7ImagePath,
      tooltip: this.categoryData.toolTip,
      fetchFromScene7: this.categoryData.fetchFromScene7,
      activateColorization: this.categoryData.activateColorization,
      newProduct: this.categoryData.newProduct,
      ULClassified: this.categoryData?.productDetails?.productInfo?.ulClassified,
      catLevel: this.categoryData?.productDetails?.productInfo?.catLevel,
      gender: this.categoryData?.productDetails?.productInfo?.gender,
      mediaSet: this.categoryData.mediaSet,
      hideOnWeb: this.categoryData.hideOnWeb,
      customField1: this.categoryData.customField1,
      customField2: this.categoryData.customField2,
      internalComments: this.categoryData.internalComments ? this.categoryData.internalComments : ''

    });
    this.copiedProdctDetails = this.categoryData?.productDetails?.attributes ? this.categoryData?.productDetails?.attributes : [];
    this.copiedProdctDetails.map((res: any) => Object.assign(res, { expand: true }));
    this.selectedProdctId = this.categoryData?.styleId;
    this.selectedVersion = this.categoryData?.version;
    if (this.categoryData?.leafNode) {
      this.addProdctSwitch = true;
    }
    else {
      this.addProdctSwitch = false;
    }
    this.switchForm(this.addProdctSwitch,false);
    this.validateFetchImage();
    this.categoryFields[0].required = true;
  }

  passAttributes(evt: any) {
    this.selectedProdctId = evt.data["styleId"];
    this.selectedVersion = evt.data["version"];
    this.apiService.getProductDetails(this.selectedProdctId, this.selectedVersion).subscribe(res => {
      this.prodctPanel = false;
      this.selectedProdctDetails = res;
      this.copiedProdctDetails = res.attributes;
      this.copiedProdctDetails.map((res: any) => Object.assign(res, { expand: true }));
      if (this.selectedProdctDetails) {
        this.addEditCategoryForm.patchValue({
          ULClassified: this.selectedProdctDetails?.productInfo.ulClassified == 1 ? true : false,
          gender: this.selectedProdctDetails?.productInfo.gender,
          catLevel: this.selectedProdctDetails?.productInfo.catLevel,
          categoryName: this.decodeHtml(this.selectedProdctDetails?.productInfo.displayName),
          categoryDesc: this.decodeHtml(this.selectedProdctDetails?.productInfo.description),
        });

      }
    })
  }

  getCtrlValue(name?: string) {
    if (!name) {
      return null;
    }
    return this.addEditCategoryForm.get(name);
  }

  saveCategory() {
    const hasMaxLengthError = this.checkMaxLengthErrors();
    const styleId = this.selectedProdctDetails?.productInfo?.styleId
      ? this.selectedProdctDetails?.productInfo?.styleId
      : this.categoryData?.styleId
        ? this.categoryData?.styleId
        : '';
    const isStyleIdMissing = this.addProdctSwitch && !styleId;

    if (!this.addEditCategoryForm.get('categoryName')?.value || !this.addEditCategoryForm.get('categoryDesc')?.value || hasMaxLengthError || isStyleIdMissing
      || (this.addEditCategoryForm.value.fetchFromScene7 && this.addEditCategoryForm.value.scene7ImagePath == "")) {
      this.invalidForm = true;
      this.apiService.createNotification('error', 'Please enter the required fields');
      return
    }
    this.invalidForm = false;
    this.categoryPayload = {};
    let post = {
      "categoryName": this.addEditCategoryForm.value.categoryName,
      "categoryDesc": this.addEditCategoryForm.value.categoryDesc,
      "parentKey": this.addEditCategoryForm.value.parentNode ? this.addEditCategoryForm.value.parentNode : 0,
      "thumbnailImg": this.addEditCategoryForm.value.categoryThumbnailImagePath,
      "tooltip": this.addEditCategoryForm.value.tooltip,
      "imageId": this.addEditCategoryForm.value.scene7ImagePath,
      "fetchFromS7": this.addEditCategoryForm.value.fetchFromScene7 ? 1 : 0,
      "product": this.addProdctSwitch ? 1 : 0,
      "catalogId": this.catalogId,
      "styleId": this.selectedProdctDetails?.productInfo?.styleId ? this.selectedProdctDetails?.productInfo?.styleId : this.categoryData?.styleId
        ? this.categoryData?.styleId : '',
      "newProduct": this.addEditCategoryForm.value.newProduct,
      "customField1": this.addEditCategoryForm.value.customField1,
      "customField2": this.addEditCategoryForm.value.customField2,
      "catImg": this.addEditCategoryForm.value.categoryImagePath,
      "swatchLogo": this.addEditCategoryForm.value.categorySwatchImagePath,
      "sizeChartImg": this.addEditCategoryForm.value.sizeChartHtmlPath,
      "catZoomImg": this.addEditCategoryForm.value.categoryZoomImagePath,
      "dim1Name": this.addEditCategoryForm.value.dim1,
      "dim2Name": this.addEditCategoryForm.value.dim2,
      "pureleafKey": null,
      "productKey": null,
      "colorization": this.addEditCategoryForm.value.activateColorization ? 1 : 0,
      "media": this.addEditCategoryForm.value.mediaSet ? 1 : 0,
      "hideOnWeb": this.addEditCategoryForm.value.hideOnWeb ? 1 : 0,
      "version": this.selectedVersion,
      "internalComments": this.addEditCategoryForm.value.internalComments ? this.addEditCategoryForm.value.internalComments : ''
    }
    if (this.isAddCategory) {
      this.apiService.addCategory(post).subscribe(res => {
        if (res.statusCode == 200 || res.statusCode == 201) {
          this.apiService.createNotification('success', res.message);
          this.addProdctSwitch = false;
          this.addEditCategoryForm.reset();
          this.emitCategoryTreeRefresh.emit('reload');
        }
      }, err => {
        this.apiService.createNotification('error', err?.error.message);
      })
    }
    else {
      if (this.addProdctSwitch) {
        this.apiService.getCategoryMultiLot(post.catalogId, this.categoryData.categorySeqNo, post.styleId, post.version).subscribe(res => {
          if (!res.data) {
            this.updateCategory(post, false);
          }
          if (res.data) {
            this.showMultiLotModal = true;
            this.categoryPayload = post;
          }
        }, err => {
          this.apiService.createNotification('error', err?.error.message);
        });
      }
      else {
        this.updateCategory(post, false);
      }
    }
  }

  checkMaxLengthErrors(): boolean {
    const controls = this.addEditCategoryForm.controls;
    return Object.keys(controls).some(key => controls[key].errors?.['maxlength']);
  }

  updateCategory(post: any, multiLotUpdateFlag: boolean) {
    Object.assign(post, { "seqno": this.categoryData.categorySeqNo, "sortOrder": this.categoryData?.sortOrder })
    this.apiService.updateCategory(post, multiLotUpdateFlag).subscribe(res => {
      if (res.statusCode == 200 || res.statusCode == 201) {
        this.apiService.createNotification('success', res.message);
        this.addProdctSwitch = false;
        this.addEditCategoryForm.reset();
        this.emitCategoryTreeRefresh.emit('reload');
      }
    }, err => {
      this.apiService.createNotification('error', err?.error.message);
    })
  }

  resetSelectedCategoryOnLeftPanel() {
    this.resetSelectedCategory.emit('reset');
  }

  handleLotUpdate(evt: any) {
    if (evt) {
      this.lots = evt;
      this.categoryData.associatedLots = evt;
      this.lotUpdate = true;
    }

  }

  disableStyleEditAccess(): boolean {
    return (this.categoryData?.productDetails?.productInfo?.salsify || this.categoryData?.productDetails?.productInfo?.deleteInd || !this.authService.MCAdd) ? true : false;
  }

  checkLotUpdate() {
    if (this.lotUpdate) {
      this.lotUpdate = false;
      this.emitUpdateLots.emit(this.lots);
    }
  }

  previewProduct() {
    this.imageLoading = true;
    this.previewModal = true;
    this.apiService.getCategoryPreviewDetail(this.seqNumber).subscribe(response => {
      this.previewData = response;
      this.imageLoading = false;
    }, (error: any) => {
      this.previewData = {};
      this.apiService.createNotification('error', error?.error.message);
      this.imageLoading = false;
    })
  }

  toggleProductDetails() {
    this.toggleProdct = !this.toggleProdct
    const prodctDetailsdisplay = this.productDetails.nativeElement.style.display;
    this.productDetails.nativeElement.style.display = prodctDetailsdisplay === 'none' ? 'block' : 'none';
  }

    onPaste(event: ClipboardEvent): void {
  const clipboardData = event.clipboardData;
  
  if (clipboardData && clipboardData.items) {
    const items = Array.from(clipboardData.items);
    
    // Check if any item in the clipboard is an image
    const hasImage = items.some(item => item.type.indexOf('image') !== -1);

    if (hasImage) {
      // Prevent the paste action entirely
      event.preventDefault();
      console.warn('Image pasting is disabled.');
    }
  }
}

}
